import { render, staticRenderFns } from "./SystemTablesOverviewView.vue?vue&type=template&id=feb116b4&scoped=true&"
import script from "./SystemTablesOverviewView.vue?vue&type=script&lang=ts&"
export * from "./SystemTablesOverviewView.vue?vue&type=script&lang=ts&"
import style0 from "./SystemTablesOverviewView.vue?vue&type=style&index=0&id=feb116b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb116b4",
  null
  
)

export default component.exports